// src/services/adminNotifications.js
//
// Domaine Admin — Notifications / annonces plateforme (Worker Admin natif)

import { apiFetch, buildQuery } from './adminHttp';

export async function getNotifications(params = {}) {
  return apiFetch(`/admin/notifications${buildQuery(params)}`, {
    method: 'GET',
  });
}

export async function createNotification(payload) {
  return apiFetch('/admin/notifications', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateNotification(payload) {
  return apiFetch('/admin/notifications/modifier', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function archiveNotification(id) {
  return apiFetch('/admin/notifications/archiver', {
    method: 'POST',
    body: JSON.stringify({ id }),
  });
}
